import { Box, makeStyles, Link, Hidden } from "@material-ui/core";
import Ah from "./assets/ah.svg";

export default function LocalOfferBlockNotEligible({ handleResetAddress, numberOfProductsAvailable }) {
  const classes = useStyle();

  return (
    <Box className={classes.notEligibleContainer}>
      <Box className={classes.notEligibleTextsContainer}>
        <Hidden mdDown>
          <Box className={classes.ah}>
            <Ah />
          </Box>
        </Hidden>
        <Box className={classes.notEligibleText}>
          Désolé, aucun de nos appareils en ligne n&apos;est disponible dans votre région mais...
        </Box>
        {numberOfProductsAvailable && (
          <Box className={classes.notEligibleTitle}>{`${numberOfProductsAvailable} ${
            numberOfProductsAvailable > 1 ? "appareils" : "appareil"
          } ailleurs en France n'${numberOfProductsAvailable > 1 ? "attendent" : "attend"} que vous`}</Box>
        )}
      </Box>
      <Box className={classes.notEligibleResetContainer}>
        <Link component="button" className={classes.resetButton} onClick={handleResetAddress}>
          Modifier l&apos;adresse
        </Link>
      </Box>
    </Box>
  );
}

const useStyle = makeStyles((theme) => ({
  ah: {
    position: "absolute",
    right: -50,
    top: -18,
  },
  resetButton: {
    fontSize: 16,
    fontWeight: 500,
    color: theme.palette.secondary.main,
    textDecoration: "underline",
  },
  notEligibleContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    backgroundColor: "#F9F9F9",
    borderRadius: 12,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(6),
    [theme.breakpoints.up("md")]: {
      marginLeft: 56,
    },
    [theme.breakpoints.down("md")]: {
      borderRadius: 0,
      display: "block",
    },
  },
  notEligibleTextsContainer: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    padding: theme.spacing(4),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
  },
  notEligibleTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: theme.palette.secondary.main,
  },
  notEligibleText: {
    fontSize: 19,
    fontWeight: 400,
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(2),
  },
  notEligibleResetContainer: {
    display: "flex",
    alignItems: "end",
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(2),
    },
  },
  underline: {
    textDecoration: "underline",
    textDecorationColor: "#FFE58A",
    textDecorationThickness: "8px",
  },
}));
